function pug_attr(t,e,n,r){if(!1===e||null==e||!e&&("class"===t||"style"===t))return"";if(!0===e)return" "+(r?t:t+'="'+t+'"');var f=typeof e;return"object"!==f&&"function"!==f||"function"!=typeof e.toJSON||(e=e.toJSON()),"string"==typeof e||(e=JSON.stringify(e),n||-1===e.indexOf('"'))?(n&&(e=pug_escape(e))," "+t+'="'+e+'"'):" "+t+"='"+e.replace(/'/g,"&#39;")+"'"}
function pug_classes(s,r){return Array.isArray(s)?pug_classes_array(s,r):s&&"object"==typeof s?pug_classes_object(s):s||""}
function pug_classes_array(r,a){for(var s,e="",u="",c=Array.isArray(a),g=0;g<r.length;g++)(s=pug_classes(r[g]))&&(c&&a[g]&&(s=pug_escape(s)),e=e+u+s,u=" ");return e}
function pug_classes_object(r){var a="",n="";for(var o in r)o&&r[o]&&pug_has_own_property.call(r,o)&&(a=a+n+o,n=" ");return a}
function pug_escape(e){var a=""+e,t=pug_match_html.exec(a);if(!t)return e;var r,c,n,s="";for(r=t.index,c=0;r<a.length;r++){switch(a.charCodeAt(r)){case 34:n="&quot;";break;case 38:n="&amp;";break;case 60:n="&lt;";break;case 62:n="&gt;";break;default:continue}c!==r&&(s+=a.substring(c,r)),c=r+1,s+=n}return c!==r?s+a.substring(c,r):s}
var pug_has_own_property=Object.prototype.hasOwnProperty;
var pug_match_html=/["&<>]/;
function pug_style(r){if(!r)return"";if("object"==typeof r){var t="";for(var e in r)pug_has_own_property.call(r,e)&&(t=t+e+":"+r[e]+";");return t}return r+""}function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (continueBtnText, doneText, hasNarration, hasPrompt, i18n, images, prompt, submitUp) {
      pug_mixins["image"] = pug_interp = function(imageUrl, klass, alt){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cimg" + (pug_attr("class", pug_classes([klass], [true]), false, true)+pug_attr("src", imageUrl, true, true)+pug_attr("alt", alt, true, true)) + "\u003E";
};
pug_html = pug_html + "\u003Cspan class=\"screen-reader\" id=\"title\" tabindex=\"0\"\u003E" + (null == (pug_interp = i18n("screen-reader.horizontal-series.total-pages", {smart_count: images.length})) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003Cdiv class=\"content-wrapper content-fill slide-up\"\u003E\u003Cdiv class=\"carousel content-fill delay-6 draggy block-v-xl\"\u003E\u003Cdiv" + (" class=\"carousel-slider content-fill clearfix\""+pug_attr("style", pug_style(`width:${images.length * 100}%;`), true, true)) + "\u003E";
// iterate images
;(function(){
  var $$obj = images;
  if ('number' == typeof $$obj.length) {
      for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
        var item = $$obj[i];
pug_html = pug_html + "\u003Cdiv" + (" class=\"carousel-item content-fill\""+pug_attr("style", pug_style(`width: ${100 / images.length}%;`), true, true)+pug_attr("id", `carousel-item-${i}`, true, true)+" tabindex=\"0\"") + "\u003E\u003Cdiv class=\"carousel-item-container content-lg-fill content-sm-ver content-md-ver\"\u003E";
var size = _.compact([item.image, item.caption]).length
var cols = size == 2 ? "col-lg-6" : ""
if (item.image) {
pug_html = pug_html + "\u003Cdiv" + (pug_attr("class", pug_classes(["img-container","col-sm-12","content-lg-ver",cols], [false,false,false,true]), false, true)) + "\u003E";
pug_mixins["image"](item.image, 'img');
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
if (item.caption) {
pug_html = pug_html + "\u003Cdiv" + (pug_attr("class", pug_classes(["caption","content-fit","col-sm-12","content-lg-ver",cols], [false,false,false,false,true]), false, true)) + "\u003E\u003Cdiv class=\"text-center text-md block-v-lg\"\u003E" + (null == (pug_interp = item.caption) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;
      var item = $$obj[i];
pug_html = pug_html + "\u003Cdiv" + (" class=\"carousel-item content-fill\""+pug_attr("style", pug_style(`width: ${100 / images.length}%;`), true, true)+pug_attr("id", `carousel-item-${i}`, true, true)+" tabindex=\"0\"") + "\u003E\u003Cdiv class=\"carousel-item-container content-lg-fill content-sm-ver content-md-ver\"\u003E";
var size = _.compact([item.image, item.caption]).length
var cols = size == 2 ? "col-lg-6" : ""
if (item.image) {
pug_html = pug_html + "\u003Cdiv" + (pug_attr("class", pug_classes(["img-container","col-sm-12","content-lg-ver",cols], [false,false,false,true]), false, true)) + "\u003E";
pug_mixins["image"](item.image, 'img');
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
if (item.caption) {
pug_html = pug_html + "\u003Cdiv" + (pug_attr("class", pug_classes(["caption","content-fit","col-sm-12","content-lg-ver",cols], [false,false,false,false,true]), false, true)) + "\u003E\u003Cdiv class=\"text-center text-md block-v-lg\"\u003E" + (null == (pug_interp = item.caption) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
if (images.length > 1) {
pug_html = pug_html + "\u003Cdiv class=\"pagination\"\u003E";
// iterate images
;(function(){
  var $$obj = images;
  if ('number' == typeof $$obj.length) {
      for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
        var item = $$obj[i];
pug_html = pug_html + "\u003Cbutton" + (" class=\"dot\""+pug_attr("data-page", i, true, true)) + "\u003E\u003C\u002Fbutton\u003E";
      }
  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;
      var item = $$obj[i];
pug_html = pug_html + "\u003Cbutton" + (" class=\"dot\""+pug_attr("data-page", i, true, true)) + "\u003E\u003C\u002Fbutton\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cdiv" + (pug_attr("class", pug_classes(["slide-footer","block-v-lg",submitUp ? "slide-footer--up slide-down" : "slide-up"], [false,false,true]), false, true)) + "\u003E";
if (hasPrompt) {
pug_html = pug_html + "\u003Cdiv class=\"slide-footer-touched\"\u003E\u003Cbutton class=\"btn btn-muted btn-done text-ellipsis\" id=\"done-btn\"\u003E" + (null == (pug_interp = doneText || i18n("buttons.continue")) ? "" : pug_interp) + "\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E";
if (typeof prompt === "string") {
pug_html = pug_html + "\u003Cdiv class=\"slide-footer-prompt text-uppercase text-bold\"\u003E\u003Cdiv class=\"slide-footer-prompt-content content-ver\" id=\"prompt\"\u003E" + (null == (pug_interp = prompt) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
}
else {
pug_html = pug_html + "\u003Cdiv class=\"slide-footer-prompt\"\u003E\u003Cbutton class=\"btn btn-muted btn-done text-ellipsis content-ver\" id=\"prompt-btn\"\u003E" + (null == (pug_interp = continueBtnText || doneText || i18n("buttons.continue")) ? "" : pug_interp) + "\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E";
}
if (hasNarration) {
pug_html = pug_html + "\u003Cdiv class=\"slide-footer-narration\"\u003E\u003Cdiv class=\"narration-progress btn btn-muted\"\u003E\u003Cdiv class=\"narration-progress-bar\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"wave-ellipse\"\u003E\u003Cspan class=\"bullet delay-1 block-inline\"\u003E&bullet;\u003C\u002Fspan\u003E\u003Cspan class=\"bullet delay-2 block-inline\"\u003E&bullet;\u003C\u002Fspan\u003E\u003Cspan class=\"bullet delay-3 block-inline\"\u003E&bullet;\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
    }.call(this, "continueBtnText" in locals_for_with ?
        locals_for_with.continueBtnText :
        typeof continueBtnText !== 'undefined' ? continueBtnText : undefined, "doneText" in locals_for_with ?
        locals_for_with.doneText :
        typeof doneText !== 'undefined' ? doneText : undefined, "hasNarration" in locals_for_with ?
        locals_for_with.hasNarration :
        typeof hasNarration !== 'undefined' ? hasNarration : undefined, "hasPrompt" in locals_for_with ?
        locals_for_with.hasPrompt :
        typeof hasPrompt !== 'undefined' ? hasPrompt : undefined, "i18n" in locals_for_with ?
        locals_for_with.i18n :
        typeof i18n !== 'undefined' ? i18n : undefined, "images" in locals_for_with ?
        locals_for_with.images :
        typeof images !== 'undefined' ? images : undefined, "prompt" in locals_for_with ?
        locals_for_with.prompt :
        typeof prompt !== 'undefined' ? prompt : undefined, "submitUp" in locals_for_with ?
        locals_for_with.submitUp :
        typeof submitUp !== 'undefined' ? submitUp : undefined));
    ;;return pug_html;};module.exports=template;